/* eslint-disable */
import React from 'react'

function Logo({ settings, teamLogoId }) {
    let url
    let height = settings.svgWidth * 0.08
    const x = settings.svgWidth / 1.2
    let y = settings.margin.top / 4

    if (settings.shape === 'twitter') {
        height = settings.svgWidth * 0.06
    }

    if (teamLogoId === 'primary') {
        url = `https://www.mlbstatic.com/team-logos/league-on-dark/1.svg`
    } else if (teamLogoId === 'savant') {
        url = 'https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg'
    } else if (teamLogoId === 'savant-logo') {
        height = settings.svgWidth * 0.1
        y = settings.margin.top / 6
        url = 'https://baseballsavant.mlb.com/site-core/images/savant-logo.svg'
    } else {
        url = `https://www.mlbstatic.com/team-logos/${teamLogoId}.svg`
    }
    return (
        <g id="logo" transform="translate(0,0)">
            <image href={url} x={x} y={y} height={height} />
        </g>
    )
}

export default Logo
